<template>
  <div class="culture">
    <!--<img class="dzxcsc" src="@/assets/images/dzxcsc.png" />-->
    <p class="title">品牌故事</p>
    <div class="sides center">
      <a> </a>
      <a class="short"> </a>
      <a class="short"> </a>
      <a class="short"> </a>
    </div>
    <div style="width: 100%;display: flex;justify-content: center;">
      <img src="http://channel-oss.oss-cn-shanghai.aliyuncs.com/d42e4f2e-2c85-4aed-addb-ad5d57d7a897" width="80%">
    </div>
    <!--<el-row type="flex" class="row-bg world" justify="center">
      <el-col :span="20">
        <p class="text">品牌宣传语：发快运 就选壹米滴答</p>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg mary" justify="center">
      <el-col :span="20">
        <el-col class="picture" :span="11">
          <img class="banner" src="@/assets/images/huobanwenhua1.png" />
        </el-col>
        <el-col class="main" :span="13">
          <p class="caption">愿景与使命</p>
          <div class="sides">
            <a> </a>
            <a class="short"> </a>
            <a class="short"> </a>
            <a class="short"> </a>
          </div>
          <p>愿景——客户首选的、基于物流的综合服务平台</p>
          <p>使命——提供有竞争力的物流产品和服务，助力中小物流企业发展</p>
          <p style="color: #666">
            壹米滴答升级使命为“提供有竞争力的物流产品和服务，助力中小物流企业发展”，中小物流即加盟网点群体。壹米滴答升级投入，打造时效、服务竞争力，并要求各级人员从“管理思维”向“服务思维”转变，因地制宜推出创业扶持政策，助力网点发展壮大。
          </p>
        </el-col>
      </el-col>
    </el-row>
    <div class="graphics">
      <img class="banner" src="@/assets/images/shiming1.png" />
      &lt;!&ndash; <div class="word">
                <p class="tit">企业愿景和使命</p>
            </div> &ndash;&gt;
      <div class="content">
        &lt;!&ndash; <el-row type="flex"
                        class="row-bg word "
                        justify="center">
                    <el-col :span="24">
                        <p class="tit">价值观</p>
                    </el-col>
                </el-row> &ndash;&gt;
        <el-row type="flex" class="row-bg substance" justify="center">
          <el-col :span="20">
            <el-col :span="12">
              &lt;!&ndash; <p class="head">一样的梦想，愿景</p>
                            <p>愿景是壹米滴答“愿望的景象”，是我们肩负使命而趋向的未来发展途径，它蕴含着壹米滴答人内心追求的境界，是确立战略目标和制定战略的重要依据，它激励着全员朝着共同的理想努力奋进。</p>
                            <p class="head">一样的初心，使命，让连接更智能，让物流更高效</p>
                            <p>使命是壹米滴答对初心的探寻，阐释了我们存在的意义、生存目的和意图，是我们进行所有活动的根本原因，它回答的是“我们要做什么，我们为什么要这么做”的问题。</p> &ndash;&gt;
              <p class="head">价值观</p>
              <div class="sides">
                <a> </a>
                <a class="short"> </a>
                <a class="short"> </a>
                <a class="short"> </a>
              </div>
              <p>正直进取 成就伙伴 学习创新 感恩分享 自我批判</p>
              <p style="color: #666">
                价值观决定了我们日常行动的方式，是指导企业行为和员工行为的一系列基本准则和信条，起着行为取向、评价原则、评价标准的作用。核心价值观是基本价值观和有关理念的统领，当基本价值观或有关理念的逻辑展开过程中出现冲突或难以兼顾的时候，核心价值观就是评判标准
              </p>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="graphics superior">
      <img class="banner" src="@/assets/images/jiazhiguan2.png" />
      <div class="content">
        <el-row type="flex" class="row-bg substa" justify="center">
          <el-col :span="20">
            <el-col :span="12" :offset="12">
              <p class="head">理念</p>
              <div class="sides">
                <a> </a>
                <a class="short"> </a>
                <a class="short"> </a>
                <a class="short"> </a>
              </div>
              <p>人才理念：尊重人 培养人 成就人</p>
              <p>用人理念：能者上 平者让 庸者下</p>
              <p>执行理念：认真快 坚守承诺 没有借口 只有结果</p>
              &lt;!&ndash; <p class="head">壹样的坚持·价值观
                                正直进取 成就伙伴 学习创新 感恩分享 自我批判
                            </p>
                            <p>价值观决定了我们日常行动的方式，是指导企业行为和员工行为的一系列基本准则和信条，起着行为取向、评价原则、评价标准的作用。核心价值观是基本价值观和有关理念的统领，当基本价值观或有关理念的逻辑展开过程中出现冲突或难以兼顾的时候，核心价值观就是评判标准</p> &ndash;&gt;
              &lt;!&ndash; <p class="head">人才理念：尊重人，培养人，成就人</p>
                            <p>用人理念：念者上，平者让，庸者下</p>
                            <p>执行理念：认真快，坚守承诺，没有借口，只有结果</p> &ndash;&gt;
              &lt;!&ndash; <p class="head">壹样的风范·企业精神——赢</p>
                            <p>企业精神是企业在发展过程中逐渐形成的一种为全体员工所认同的群体意识和心理状态。它既表达了企业的精神状态所达到的境界，也是企业追求目标时展现的风貌。
                                想赢：渴望脱颖而出，有强烈的赢的欲望。
                                敢赢：成不骄、败不馁，勇往直前、百折不挠，有赢的决心。
                                能赢：乐于分享、成就彼此、携手前行，共创未来。
                                共赢：勤于钻研、勇于创变，德才兼备、业务过硬，有赢的把握。
                            </p> &ndash;&gt;
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-row type="flex" class="row-bg foot" justify="center">
      <el-col class="inner" :span="20">
        <el-col class="main" :span="13">
          <p class="caption">企业精神</p>
          <div class="sides">
            <a> </a>
            <a class="short"> </a>
            <a class="short"> </a>
            <a class="short"> </a>
          </div>
          <p>赢——想赢 敢赢 能赢 共赢</p>
          <p style="color: #666">
            企业精神是企业在发展过程中逐渐形成的一种为全体员工所认同的群体意识和心理状态。它既表达了企业的精神状态所达到的境界，也是企业追求目标时展现的风貌。
            想赢：渴望脱颖而出，有强烈的赢的欲望。
            敢赢：成不骄、败不馁，勇往直前、百折不挠，有赢的决心。
            能赢：乐于分享、成就彼此、携手前行，共创未来。
            共赢：勤于钻研、勇于创变，德才兼备、业务过硬，有赢的把握。
          </p>
          &lt;!&ndash; <p>企业精神是企业在发展过程中逐渐形成的一种为全体员工所认同的群体意识和心理状态。它既表达了企业的精神状态所达到的境界，也是企业追求目标时展现的风貌。
                        想赢：渴望脱颖而出，有强烈的赢的欲望。
                        敢赢：成不骄、败不馁，勇往直前、百折不挠，有赢的决心。
                        能赢：乐于分享、成就彼此、携手前行，共创未来。
                        共赢：勤于钻研、勇于创变，德才兼备、业务过硬，有赢的把握。
                    </p> &ndash;&gt;
        </el-col>
        <el-col class="picture" :span="11">
          <img class="banner" src="@/assets/images/huobanwenhua.png" />
        </el-col>
      </el-col>
    </el-row>-->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.culture {
  position: relative;
  .dzxcsc {
    position: absolute;
    right: 0;
    top: -90px;
    width: 100px;
  }
  .title {
    margin-bottom: 0 !important;
  }
  .center {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .word {
    p {
      // text-align: center;
      font-size: 16px;
      line-height: 30px;
    }
  }
  .world {
    margin-top: 60px;
    p {
      font-size: 16px;
      line-height: 30px;
    }
    .text {
      margin-top: 10px;
    }
  }
  .mary {
    margin-top: 60px;
    .main {
      padding-left: 60px;
      .caption {
        font-size: 24px;
        margin-top: 60px;
      }
      p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }
    }
    p {
      line-height: 36px;
    }
    .picture {
      .banner {
        width: 100%;
      }
    }
  }
  // .text {
  //     width: 80%;
  //     position: relative;
  //     left: 50%;
  //     transform: translateX(-50%);
  //     text-align: center;
  // }
  .graphics {
    margin-top: 60px;
    position: relative;
    //background-image: url(../../assets/images/hexinjiazhi.png);
    background-attachment: fixed;
    background-size: 100% auto;
    .banner {
      width: 100%;
    }
    .content {
      position: absolute;
      top: 78px;
      width: 100%;
      .word {
        .tit {
          font-size: 28px;
          text-align: center;
        }
      }
      .substance {
        margin-top: 28px;
        .el-col {
          .head {
            font-size: 24px;
            margin-top: 32px;
          }
          p {
            margin-top: 16px;
            font-size: 16px;
            color: #333;
            line-height: 36px;
          }
        }
      }
    }
  }
  .superior {
    margin-top: -3px;
    background-image: url(../../assets/images/jiazhiguan.png);
    background-attachment: fixed;
    background-size: 100% auto;

    .banner {
      width: 100%;
    }
    .substa {
      position: relative;
      top: -20px;
      .el-col {
        .head {
          font-size: 24px;
          margin-top: 32px;
        }
        p {
          margin-top: 16px;
          font-size: 16px;
          color: #333;
          line-height: 36px;
        }
      }
    }
  }
  .foot {
    // margin: 80px 0;
    background-color: #fff;
    margin-top: -6px;
    .inner {
      margin: 60px 0;
      // margin-bottom: 80px;
    }
    .main {
      padding-right: 160px;
      .caption {
        font-size: 24px;
        margin-top: 15px;
      }
      p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }
    }
    p {
      line-height: 36px;
    }
    .picture {
      .banner {
        width: 100%;
      }
    }
  }
}
</style>
